<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
    <h2>{{ subtitle }}</h2>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String,
    subtitle: String
  }
}
</script>

<style scoped>
h1 {
  font-weight: normal;
}
</style>
